import React from 'react';
import { Route, Switch, RouteComponentProps } from 'react-router-dom';

import Login from './Login';

export default ((props) => {
  return (
    <Switch>
      <Route path={`${props.match.url}/login`} component={Login} />
    </Switch>
  );
}) as React.FC<RouteComponentProps>;
